import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(239,246,255) 18%, rgb(239,246,255) 78%, rgb(219,234,254) 100%)'
  }} data-id="element-169">
      <div className="mx-auto max-w-3xl" data-id="element-170">
        <div className="rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(59,130,246,0.3)'
      }} data-id="element-171">
          {/* Header */}
          <div className="px-6 py-5 text-center" style={{
          background: 'linear-gradient(135deg, rgb(29,78,216), rgb(37,99,235))'
        }} data-id="element-172">
            <div className="text-5xl mb-3" data-id="element-173">🛡️</div>
            <h2 className="text-xl sm:text-2xl font-black text-white m-0" data-id="element-174">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-6 text-center" style={{
          backgroundColor: 'rgb(239,246,255)'
        }} data-id="element-175">
            <p className="text-sm text-gray-600 m-0 mb-4" data-id="element-176">
              Revisá el material tranquilo durante 7 días.
            </p>

            <p className="text-xl sm:text-2xl font-black text-blue-700 m-0 mb-2" data-id="element-177">
              Si no te sirve, te devolvemos el 100%.
            </p>

            <p className="text-sm sm:text-base font-bold text-gray-900 m-0" data-id="element-178">
              Sin vueltas. Sin drama.
            </p>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 text-center border-t" style={{
          backgroundColor: 'rgb(255,255,255)',
          borderColor: 'rgba(59,130,246,0.15)'
        }} data-id="element-179">
            <p className="text-xs text-gray-500 m-0 leading-5" data-id="element-180">
              Más de 1.800 estudiantes ya confiaron en este sistema.
            </p>
          </div>
        </div>
      </div>
    </section>;
}